var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"title":"show","color":"agency-color-primary","fab":"","small":"","depressed":"","link":"","target":"_blank","href":_vm.documentUrl}},[_c('v-icon',[_vm._v("mdi-eye")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }